// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  float: right;
  margin-top: 20px;
  margin-right: 6px;
}

.release-notes-bell-btn {
  position: relative;
  border: 0;
  background: transparent;
  color: #0B2D71;
  font-size: 1.85rem;
  line-height: 1;
  padding: 0;
  margin-right: 10px;
  transition: color 0.2s ease-in-out;
}

.release-notes-bell-btn:hover {
  cursor: pointer;
  color: #0066B2;
}

.release-notes-unread-dot {
  position: absolute;
  top: 2px;
  right: -1px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #dc2626;
}

.release-notes-dropdown-content {
  width: 330px;
}

.release-notes-dropdown-header {
  font-weight: 800;
  color: #0B2D71;
  margin-bottom: 10px;
}

.release-notes-state {
  padding: 6px 0;
}

.release-note-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 280px;
  overflow-y: auto;
}

.release-note-list li {
  padding: 9px 10px;
  margin-bottom: 8px;
  border-radius: 6px;
  border-left: 4px solid #0066B2;
  background: #EFEFEF;
}

.release-note-version {
  font-weight: 700;
  color: #0B2D71;
}

.release-note-list li.unread .release-note-version {
  font-weight: 700;
}

.release-note-list a {
  text-decoration: none;
}

.release-note-date {
  font-size: 12px;
  font-weight: 400;
  color: #777;
}

.release-note-summary {
  font-size: 12px;
  margin-top: 4px;
}

.release-notes-view-all {
  border: 0;
  background: transparent;
  font-weight: 800;
  padding: 10px 0 0;
}

.release-notes-view-all:hover {
  text-decoration: underline;
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
